import { Modal } from 'antd'
import { Parser } from 'html-to-react'
import useTranslation from '@/hooks/useTranslation'

import Close from '../../../svgs/CloseModal'

const htmlToReactParser = new Parser()

export default function MissingInfo({ open, setOpen, notes }) {
  const { t } = useTranslation()

  return (
    <Modal
      className='!w-[30rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='flex items-center justify-between mb-24'>
        <h3 className='text-gray text-xl font-semibold'>
          {t('dashboard.MissingInfo')}
        </h3>
        <Close style='cursor-pointer w-20' onClick={() => setOpen(false)} />
      </div>

      {notes?.map((ele, i) => (
        <div key={i} className='mb-16 last:mb-0 border-b border-[#DDD] last:border-b-0 pb-16 last-pb-0'>
          <div className='text-[#6D6D6D] text-sm leading-8 mb-8'>
            {htmlToReactParser.parse(ele.info)}
          </div>

          <div className='info'>
            <p className='text-black text-sm font-semibold'>
              <span className='text-green'>{t('Added At')}:</span>{' '}
              {ele.created_at?.substr(0, 10).split('-').reverse().join('-')}
            </p>
          </div>
        </div>
      ))}
    </Modal>
  )
}
